import { render, staticRenderFns } from "./PrivacyPortal.vue?vue&type=template&id=e62ec5d2"
import script from "./PrivacyPortal.vue?vue&type=script&lang=js"
export * from "./PrivacyPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports